import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import validationSchema from 'src/utils/validationSchema';

import { useTranslate } from 'src/locales';
import { useChannelContext } from 'src/pages/channel/hooks';
import { useMicrosoftTeamsAuthPopup } from 'src/hook/useMicrosoftTeamsAuthPopup';

export function useTeamsStep2() {
  const { t } = useTranslate('translation');
  const { state: channelState, handleChannelName, onChangeStep } = useChannelContext();
  const { loginWithMicrosoftTeams, isTeamsConnected } = useMicrosoftTeamsAuthPopup();

  const schema = validationSchema([{ name: 'channelName', required: true }], t);

  type FormValues = { channelName: string };

  const methods = useForm<FormValues>({
    mode: 'all',
    resolver: zodResolver(schema),
    defaultValues: { channelName: '' },
    values: { channelName: channelState.channelName },
  });

  const { handleSubmit, watch, formState, getValues } = methods;

  const channelName = watch('channelName');

  const onSubmit = handleSubmit((data) => {
    handleChannelName(data.channelName);
    methods.reset();
    onChangeStep('next');
  });

  const handleSignIn = () => {
    handleChannelName(getValues('channelName'));
    loginWithMicrosoftTeams();
  };

  const isNextDisabled = !channelName || !isTeamsConnected || formState.isSubmitting;
  const isSignInDisabled = !channelName || formState.isSubmitting;

  return {
    methods,
    channelName,
    isTeamsConnected,
    isNextDisabled,
    isSignInDisabled,
    handleSignIn,
    onSubmit,
  };
}
